import React, { createContext, useState, useContext, useMemo } from "react"
import PropTypes from "prop-types"
const ChatbotContext = createContext()

export const useChatbot = () => useContext(ChatbotContext)

const ChatbotProvider = ({ children }) => {
  const chatHistory = localStorage.getItem("chatHistory")
  const [isChatbotVisible, setIsChatbotVisible] = useState(false)
  const [messages, setMessages] = useState(chatHistory ? JSON.parse(chatHistory) : [])

  const openChatbot = () => setIsChatbotVisible(true)
  const closeChatbot = () => setIsChatbotVisible(false)

  const contextValue = useMemo(
    () => ({
      isChatbotVisible,
      messages,
      setMessages,
      openChatbot,
      closeChatbot,
    }),
    [isChatbotVisible, messages, setMessages, openChatbot, closeChatbot],
  )

  return <ChatbotContext.Provider value={contextValue}>{children}</ChatbotContext.Provider>
}

ChatbotProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export default ChatbotProvider
